module.exports = __webpack_public_path__ + "static/media/swiper-img1-card2.96194691.png";